import { kebabCase } from 'lodash';
import { getSummary } from '@/pages/CompanyReport/redux/selectors';
import { useSelector } from 'react-redux';
import type { PrimaryCountryISOElseGlobal } from '@/constants/countries';

import { getTopCompanies } from './utils';
import { useGqlUserScreener } from '@/hooks/useGridView/useGqlUserScreener';
import { useInvestingIdeaScreener } from '@/hooks/useInvestingIdeaScreener';

type NextStepInfoParams = {
  gridViewOptionId: string;
  section: string;
};

export const useNextStepInfo = ({
  gridViewOptionId,
  section,
}: NextStepInfoParams) => {
  const reduxSummary = useSelector((state) => getSummary(state, {}));
  const market =
    reduxSummary.countryISO.toLowerCase() as PrimaryCountryISOElseGlobal;
  const industry =
    section === 'dividend'
      ? ''
      : kebabCase(reduxSummary.industryData.primaryName);
  const name = reduxSummary.name;

  const { data: investingIdeaScreenerData, status: gridRulesStatus } =
    useGqlUserScreener({
      id: parseFloat(gridViewOptionId),
    });

  const rules = investingIdeaScreenerData?.userScreener.filterJson;

  const {
    companies,
    totalRecords,
    status: gridCompaniesStatus,
  } = useInvestingIdeaScreener({
    rawRules: rules || '',
    market,
    industry,
    gridViewId: gridViewOptionId,
    initPage: 0,
    pageSize: 3,
    isInfinite: false,
    returnRecentCompaniesOnly: false,
  });

  const topCompanies = getTopCompanies(companies, 3, reduxSummary.companyId);

  return {
    companies: topCompanies,
    totalRecords,
    gridRulesStatus,
    gridCompaniesStatus,
    name,
    market,
    industry,
    companyId: reduxSummary.companyId,
  };
};
